import StocksPage from './StocksPage.vue';
import StocksMapPage from './StocksMapPage.vue';

export * from './types';
export {
    StocksPage as default,
    StocksPage,
    StocksMapPage
};
